import React from "react";
import "../styles/Playground.css";
import logoIcon from "../assets/mainicon.png";
import buttonImage2 from "../assets/googleplay.png";
import buttonImage1 from "../assets/appstore.png";

const Playground = () => {
  const goToPlayStore = () => {
    window.open(
      "https://play.google.com/store",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const goToAppStore = () => {
    window.open(
      "https://www.apple.com/app-store/",
      "_blank",
      "noopener,noreferrer"
    );
  };
  return (
    <div className="playground-container">
      <div className="content">
        <img src={logoIcon} alt="Playground Icon" className="icon" />
        <p className="text">
          Artify playground is only available on desktop.
          <br />
          Sign in from your desktop to use imagine playground.
        </p>
        <div style={{ display: "flex", gap: "5px", marginBottom: "10px" }}>
          <button
            className="footer-button"
            onClick={goToAppStore}
            style={{ border: "none", background: "none", padding: 0 }}
          >
            <img
              src={buttonImage1}
              alt="App Store"
              style={{ width: "100px", height: "auto", cursor: "pointer" }}
            />
          </button>
          <button
            className="footer-button"
            onClick={goToPlayStore}
            style={{ border: "none", background: "none", padding: 0 }}
          >
            <img
              src={buttonImage2}
              alt="Play Store"
              style={{ width: "100px", height: "auto", cursor: "pointer" }}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Playground;
